export const flyerPath = '/flyer/:flyerId/:flyerPage(\\d+)';
export const flyersPath = '/flyers';
export const storesPath = '/flyer/:flyerId/stores/:nearestStoreId?';
export const tagsPath = '/flyer/:flyerId/tags';
export const tagPath = '/flyer/:flyerId/tags/:tagId';
export const flyerBasePathWithoutPage = '/flyer/:flyerId';
export const customLabelFlyerPath = '/flyer-by-custom-label/pages/:flyerPage(\\d+)'; // TODO[GB]: controllare questa rotta
export const flyerPagesPath = '/flyer-pages/:flyerId/:flyerPage(\\d+)';

export const allPaths = [
  flyerPath,
  customLabelFlyerPath,
  flyerPagesPath,
  flyersPath,
  storesPath,
  tagsPath,
  tagPath,
];

export const pathDrawerRules = {
  [flyerPath]: false,
  [flyersPath]: true,
  [storesPath]: true,
  [tagsPath]: true,
  [tagPath]: true,
};
